import { useAppSelector } from '../../../../store/hooks'
import NotImplemented from '../../../common/pages/NotImplemented'

const DateAndTime = () => {
    const theme = useAppSelector((state) => state.theme.theme)

    return (
        <NotImplemented
            header={{
                header: 'Date & Time',
                buttons: [
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                ],
            }}
            label={
                <>
                    <span className="text-success">Date &amp; Time</span> has
                    not been implemented yet!
                </>
            }
            description={<p>Coming soon!</p>}
        />
    )
}

export default DateAndTime
